let formObjs = [];

export function init() {
    const placeholderFormEls = document.querySelectorAll(".js-form-donate");

    let replacedFormsCount = 0;

    htmx.on("htmx:afterSwap", function (event) {
        if (
            [
                "donate-module-donate-header",
                "donate-module-donate-header-mobile",
                "donate-module-donate-content",
            ].includes(event.target.id)
        ) {
            replacedFormsCount++;
        }

        // If the number of replaced Form Elements is equal to the initial number of placeholder Form Elements
        // we can initialise the form objects
        if (replacedFormsCount === placeholderFormEls.length) {
            const formEls = document.querySelectorAll(".js-form-donate");

            if (!formEls) {
                return;
            }

            // There could be multiple forms so initialise each
            formEls.forEach((el) => {
                let form = new Form(el);

                let formObj = {
                    id: el.id,
                    form: form,
                };

                formObjs.push(formObj);

                form.init();
            });

            // Monitor for changes to amount and type and gift aid fields
            window.addEventListener("changedDonationType", (e) => {
                let formObj = formObjs.find(
                    (obj) => obj.id === e.detail.formId
                );

                if (formObj) {
                    triggerKeyupEvent(formObj.form.form);
                }
            });

            window.addEventListener("changedDonationAmount", (e) => {
                let formObj = formObjs.find(
                    (obj) => obj.id === e.detail.formId
                );

                if (formObj) {
                    triggerKeyupEvent(formObj.form.form);
                }
            });
        }
    });
}

function triggerKeyupEvent(form) {
    // Dispatch change event on donationType and donationAmount inputs
    // for Freeform JS to pick up for field rule handling
    const donationTypeInput = form.querySelector('input[name="donationType"]'),
        donationAmountInput = form.querySelector(
            'input[name="donationAmount"]'
        );

    donationTypeInput.dispatchEvent(new Event("keyup"));
    donationTypeInput.dispatchEvent(new Event("change"));

    donationAmountInput.dispatchEvent(new Event("keyup"));
    donationAmountInput.dispatchEvent(new Event("change"));
}

class Form {
    constructor(form) {
        this.form = form;
    }

    init() {
        this.setupEventHandlers();
    }

    setupEventHandlers() {
        const _this = this;

        // Run field validation when next steps button clicked
        _this.form.querySelectorAll(".js-donate-next-step").forEach((btn) => {
            btn.addEventListener("click", (e) => {
                const currentBlock = btn.closest(".js-form-panel"),
                    nextBlock = currentBlock.parentElement.nextElementSibling;

                let fieldsValid = false;

                // Search for any block errors and remove them before validating the fields
                currentBlock.querySelectorAll(".ff-errors").forEach((el) => {
                    el.remove();
                });

                // Do validation checks on required fields in current block
                fieldsValid = _this.validateBlockFields(currentBlock);

                if (fieldsValid) {
                    let nextStep = parseInt(btn.dataset.nextstep);

                    // Check if there are visible fields in the next step and if not progress 2 steps
                    if (
                        nextBlock &&
                        nextBlock.nodeName == "DIV" &&
                        nextBlock.querySelectorAll(".js-field").length ==
                            nextBlock.querySelectorAll(".js-field.hidden")
                                .length
                    ) {
                        nextStep++;
                    }

                    // Fields are valid, progress to next step
                    let event = new CustomEvent("setstep", {
                        detail: {
                            step: nextStep,
                            formId: _this.form.id,
                        },
                    });

                    window.dispatchEvent(event);
                } else {
                    _this.showErrorOnStep(
                        currentBlock,
                        "Please complete all required fields before moving to the next step."
                    );
                }
            });
        });
    }

    showErrorOnStep(step, message) {
        // Validation errors in blok fields so show error
        let paragraph = document.createElement("p");

        paragraph.appendChild(document.createTextNode(message));
        paragraph.classList.add("ff-errors");
        step.appendChild(paragraph);
    }

    validateBlockFields(block) {
        // Loop over all required fields
        for (const el of block.querySelectorAll(".js-required-field")) {
            // Find the field within and check that it has been filled/isn't empty etc
            for (const field of el.querySelectorAll(
                "input, select, textarea"
            )) {
                switch (field.tagName.toLowerCase()) {
                    case "textarea":
                    case "select":
                        if (!field.value) {
                            return false;
                        }
                        break;

                    case "input":
                        // Not a checkbox or radio input
                        if (
                            !["checkbox", "radio"].includes(field.type) &&
                            !field.value
                        ) {
                            return false;
                        }

                        if (["checkbox", "radio"].includes(field.type)) {
                            var checked = false;

                            // Loop over all inputs with the same name as this field to see if any are checked
                            block
                                .querySelectorAll(`input[name="${field.name}"]`)
                                .forEach((item) => {
                                    if (item.checked) {
                                        checked = true;
                                    }
                                });

                            if (!checked) {
                                return false;
                            }
                        }

                        break;
                }
            }
        }

        return true;
    }
}
